import React from 'react';
import { UTLabel } from '@widergy/energy-ui';

import ServiceAdherenceDetail from '../../../../../../../../components/ServiceAdherenceDetail';
import UTCheck from '../../../../../../../../components/UTCheck';

import styles from './styles';

const fieldDetailFormatter = (field, index) => (
  <div style={styles.field} key={index}>
    {field.service ? (
      [
        <UTLabel key={field.name} semibold>
          {field.name}
        </UTLabel>,
        <ServiceAdherenceDetail
          key={field.adherence}
          adherence={field.value}
          service={field.service}
          account={field.account}
        />
      ]
    ) : (
      <div style={[styles.field, styles.withoutPadding]}>
        {field.value && (
          <div style={styles.checkedBackground}>
            <UTCheck style={styles.checkedOk} />
          </div>
        )}
        <UTLabel black medium style={styles.element}>
          {field.name}
        </UTLabel>
      </div>
    )}
  </div>
);

export default fieldDetailFormatter;
